/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects'

import {
  setBloqueos,
  setCabinas,
  setCargandoInicial,
  setDataSalida,
  setDisponibilidad,
  setLoading,
  setModalCabina,
  setModalYield,
  setPasajerosAsignados,
  setPasajerosLista,
  setVisible,
} from './actions'
import {
  DECKPLAN_ABRIR_CABINA,
  DECKPLAN_ASIGNAR_CABINA,
  DECKPLAN_DESBLOQUEAR_CABINA,
  DECKPLAN_GET_PASAJEROS_LISTA,
  DECKPLAN_LOAD_DATA,
  DECKPLAN_SEND_YIELD_NOTIFICATION,
} from './actionsTypes'

import { RootState } from '../store'

import { urlIsabela, urlPinta, urlSantaCruz } from '@/common/constants/api'

import { get, post } from '@/common/helpers/api_helper'
import { notifications } from '@/common/helpers/notifications'
import { dateTimeToDate } from '@/common/helpers/utilsDate'
import {
  Acomodacion,
  Assigned,
  BookingList,
  ICabinasInfo,
  DataAsignar,
  ICabinaBloqueada,
  JsonData,
  LoadDeckplanData,
  StateDeckplan,
} from '@/common/interfaces/deckplan'

import isabelaCabins from '@/modules/Embarcaciones/Deckplan/Cabins/isabelaCabins.json'
import pintaCabins from '@/modules/Embarcaciones/Deckplan/Cabins/pintaCabins.json'

import santaCruzCabins from '@/modules/Embarcaciones/Deckplan/Cabins/santaCruzCabins.json'
import {
  coloresCabinasIsabela,
  coloresCabinasPinta,
  coloresCabinasSantaCruz,
  correoCabinasRestantes,
  createTreePassengers,
  filterCabins,
  getAssignedPassengers,
  getExtension,
  groupBy,
  tableEmailHtml,
  unlockCabinApi,
} from '@/modules/Embarcaciones/Deckplan/helpers/DeckplanHelpers'

const Deckplan = (state: RootState) => state.Deckplan

// El par (url, json de cubiertas) por embarcación lo necesitan la carga inicial y la
// recomposición de cabinas cuando falla una asignación; vive en un solo lugar para que
// las dos rutas no se desincronicen.
const datosPorEmbarcacion: Record<string, { url: string; jsonData: JsonData }> = {
  isabela: { url: urlIsabela, jsonData: isabelaCabins },
  pinta: { url: urlPinta, jsonData: pintaCabins },
  santaCruz: { url: urlSantaCruz, jsonData: santaCruzCabins },
}

const getDatosEmbarcacion = (embarcacion: string): { url: string; jsonData: JsonData } => {
  return datosPorEmbarcacion[embarcacion] ?? { url: '', jsonData: {} as JsonData }
}

const getPassengers = (url: string) => {
  return createTreePassengers(url)
}

const getDisponibilidadBySalidaId = (id: number) => {
  return get(
    `Disponibilidades?$select=CantidadCabinas,TotalCabinaTomada&$expand=TipoCabina($select=Sigla),Deck($select=Sigla)&$filter=SalidaEmbarcacionId eq ${id}`,
  )
    .then((res) => {
      return res.value
    })
    .catch((error) => {
      notifications({ ex: error })
    })
}

const getDataSalidaById = (id: number) => {
  return get(
    `SalidasEmbarcacion?$select=FechaInicio,FechaFin&$expand=Embarcacion($select=Nombre)&$filter=SalidaEmbarcacionId eq ${id}`,
  )
    .then((res) => {
      return res.value[0]
    })
    .catch((error) => {
      notifications({ ex: error })
    })
}

const getDataBloqueosBySalida = (salidaId: number) => {
  return get(
    `BloqueosNumeroTipoCabina?$filter=SalidaEmbarcacionId eq ${salidaId}`,
  )
    .then((res) => {
      return res.value
    })
    .catch((error) => {
      notifications({ ex: error })
    })
}

const getCabinaOriginalByNombre = (nombre: string) => {
  return get(`Cabinas?$select=CabinaId,Nombre&$filter=Nombre eq '${nombre}'`)
    .then((res) => {
      return res.value[0].CabinaId
    })
    .catch((error) => {
      notifications({ ex: error })
    })
}

function* getDataSalida(id: number): any {
  const salida = yield call(getDataSalidaById, id)
  const data = {
    FechaInicio: dateTimeToDate(salida.FechaInicio),
    FechaFin: dateTimeToDate(salida.FechaFin),
    Nombre: salida.Embarcacion.Nombre,
  }

  yield put(setDataSalida(data))
}

function* generateYieldNotification(
  embarcacionNombre: string,
  fechaInicioSalida: string,
  fechaFinSalida: string,
  cabinas: ICabinasInfo[],
): any {
  yield put(setModalYield(true))
  try {
    // Cabinas vacías agrupadas por deck (genérico: cubre cualquier embarcación).
    // El backend (EnviarCorreoDeckplan) envía el correo SendGrid al equipo de revenue
    // (destinatarios en BD) y la campana Courier (reemplazo del push Ravenhub deprecado).
    const agrupadasPorDeck: Map<string, ICabinasInfo[]> = groupBy(
      cabinas,
      (c: ICabinasInfo) => c.TipoCabina.Deck.Sigla,
    )
    const dataGrouped: { deck: string; cabins: ICabinasInfo[] }[] = []

    agrupadasPorDeck.forEach((cabinasDeck, deck) => {
      dataGrouped.push({ deck, cabins: cabinasDeck.filter((c) => c.cantidadPasajeros === 0) })
    })

    const dataCorreo = {
      producto: embarcacionNombre,
      fechaOperacion: `${fechaInicioSalida} - ${fechaFinSalida}`,
      htmlTableCabinasDisponibles: tableEmailHtml(dataGrouped),
    }

    yield call(correoCabinasRestantes, 'EnviarCorreoDeckplan/', dataCorreo)
  } finally {
    yield put(setModalYield(false))
  }
}

function* getPasajerosEmbarcacion(salidaEmbarcacionId: number): any {
  const listaPasajeros = yield call(
    getPassengers,
    `PasajeroEmbarcacion(${salidaEmbarcacionId})`,
  )

  const newList = structuredClone(listaPasajeros)

  yield put(
    setPasajerosLista(
      newList.sort((a: BookingList, b: BookingList) => {
        return ('' + a.bookingCode).localeCompare(b.bookingCode)
      }),
    ),
  )
}

function* getCabinas(
  salidaEmbarcacionId: number,
  embarcacion: string,
  url: string,
  dataJson: JsonData,
): any {
  const cabinas = yield call(
    filterCabins,
    url,
    embarcacion,
    salidaEmbarcacionId,
    dataJson,
  )

  yield put(setCabinas(cabinas))
}

function* getPasajerosAsignados(salidaEmbarcacionId: number): any {
  const pasajerosAsignados = yield call(
    getAssignedPassengers,
    salidaEmbarcacionId,
  )

  yield put(setPasajerosAsignados(pasajerosAsignados))
}

function* getBloqueos(salidaEmbarcacionId: number): any {
  const bloqueos = yield call(getDataBloqueosBySalida, salidaEmbarcacionId)

  yield put(setBloqueos(bloqueos))
}

function* getDisponibilidad(salidaEmbarcacionId: number): any {
  const disponibilidad = yield call(
    getDisponibilidadBySalidaId,
    salidaEmbarcacionId,
  )

  yield put(setDisponibilidad(disponibilidad))
}

function* desbloquearCabinaByNumeroTipoCabina(
  numeroTipoCabinaId: number,
  indiceCabina: number,
  cabinas: ICabinasInfo[],
  claseCabina: string,
  claseFranja: string,
  bloqueos: ICabinaBloqueada[],
): any {
  const cabinasDesbloqueadas = cabinas.map((cabina, index) => {
    if (indiceCabina === index) {
      return {
        ...cabina,
        cabFigClass: claseCabina,
        franjaFigClass: claseFranja,
        BloqueoNumeroTipoCabinaId: null,
      }
    }

    return cabina
  })

  const bloqueo = bloqueos.find(
    (x) => x.NumeroTipoCabinaId === numeroTipoCabinaId,
  )

  yield call(unlockCabinApi, bloqueo!.BloqueoNumeroTipoCabinaId)
  yield put(setCabinas(cabinasDesbloqueadas))
  yield put(
    setBloqueos(
      bloqueos.filter((x) => x.NumeroTipoCabinaId !== numeroTipoCabinaId),
    ),
  )
}

function* abrirCabinaByNumero(cabina: number): any {
  const { cabinas, pasajerosAsignados, bloqueos }: StateDeckplan = yield select(
    Deckplan,
  )

  yield put(setVisible(true))
  const indexPasajero = pasajerosAsignados.findIndex(
    (x) => x.cabina === String(cabina),
  )
  const indexCabina = cabinas.findIndex((x) => x.Numero === cabina)
  let bloqueo: ICabinaBloqueada[] = []

  if (cabinas[indexCabina].BloqueoNumeroTipoCabinaId !== null) {
    bloqueo = bloqueos.filter(
      (x) => x.NumeroTipoCabinaId === cabinas[indexCabina].NumeroTipoCabinaId,
    )
  }
  if (indexPasajero === -1) {
    yield put(
      setModalCabina({
        numero: cabina,
        isUpgrade: '',
        pasajeros: [],
        bloqueo:
          cabinas[indexCabina].BloqueoNumeroTipoCabinaId !== null
            ? bloqueo
            : [],
        cabina: '',
      }),
    )
  } else {
    yield put(
      setModalCabina({
        numero: cabina,
        isUpgrade: pasajerosAsignados[indexPasajero].isUpgrade,
        pasajeros: pasajerosAsignados[indexPasajero].pasajeros,
        bloqueo:
          cabinas[indexCabina].BloqueoNumeroTipoCabinaId !== null
            ? bloqueo
            : [],
        cabina: pasajerosAsignados[indexPasajero].cabinaAsignadaNombre,
      }),
    )
  }
}

// Se exporta para poder testear el guardado y el rollback sin navegador
export function* asignar(
  dataAsignarOld: DataAsignar,
  cabinasOld: ICabinasInfo[],
  initialDataOld: LoadDeckplanData,
  dataAcomodacionesOld: Acomodacion[],
  pasajerosAsignadosOld: Assigned[],
): any {
  const newCabinas = structuredClone(cabinasOld)
  const pasajerosAsignados = structuredClone(pasajerosAsignadosOld)
  const newInitialData = structuredClone(initialDataOld)
  const dataAsignar = structuredClone(dataAsignarOld)
  const dataAcomodaciones = structuredClone(dataAcomodacionesOld)

  yield put(setLoading(true))

  const { salidaEmbarcacion, embarcacion } = newInitialData
  const extension = yield call(getExtension, dataAsignar.pasajerosDrop)
  let assignOriginId = yield call(
    getCabinaOriginalByNombre,
    dataAsignar.acomodacionDrop,
  )

  if (
    dataAsignar.pasajerosDrop.filter(
      (x) => x.extension === 'T' || x.extension === 'S',
    ).length > 0
  ) {
    newCabinas[dataAsignar.indiceCabina].cabFigClass = 'cabsExtended'
  } else {
    switch (embarcacion) {
      case 'santaCruz':
        yield call(
          coloresCabinasSantaCruz,
          newCabinas[dataAsignar.indiceCabina],
          newCabinas[dataAsignar.indiceCabina].TipoCabina.Deck.Sigla +
            newCabinas[dataAsignar.indiceCabina].TipoCabina.Sigla,
        )
        break

      case 'isabela':
        yield call(
          coloresCabinasIsabela,
          newCabinas[dataAsignar.indiceCabina],
          newCabinas[dataAsignar.indiceCabina].TipoCabina.Sigla,
        )
        break

      case 'pinta':
        yield call(
          coloresCabinasPinta,
          newCabinas[dataAsignar.indiceCabina],
          newCabinas[dataAsignar.indiceCabina].TipoCabina.Sigla,
        )
        break

      default:
        break
    }
  }

  switch (dataAsignar.esUpgradeDowngrade) {
    case 'D':
      newCabinas[dataAsignar.indiceCabina].franjaFigClass = 'cabsDowngrade'
      break

    case 'U':
      newCabinas[dataAsignar.indiceCabina].franjaFigClass = 'cabsUpgrade'
      break

    case 'N':
      assignOriginId = null
      break

    default:
      break
  }

  newCabinas[dataAsignar.indiceCabina].cantidadPasajeros +=
    dataAsignar.pasajerosDrop.length

  yield put(setCabinas([...newCabinas]))

  const newCabina = {
    numeroTipoCabinaId: newCabinas[dataAsignar.indiceCabina].NumeroTipoCabinaId,
    cabina: String(dataAsignar.cabinaDropped),
    cabinaId: dataAsignar.droppedCabinaId,
    salidaEmbarcacionId: salidaEmbarcacion,
    isUpgrade: dataAsignar.esUpgradeDowngrade,
    extensionCrucero: extension,
    cabinaOrigenId: assignOriginId,
    pasajeros: dataAsignar.pasajerosDrop,
    cabinaAsignadaNombre:
      dataAsignar.esUpgradeDowngrade === 'D' ||
      dataAsignar.esUpgradeDowngrade === 'U'
        ? dataAcomodaciones.filter(
            (x) => x.id === dataAsignar.droppedCabinaId,
          )[0].nombre
        : dataAsignar.acomodacionDrop,
  }

  const indexCabina = pasajerosAsignados.findIndex(
    (x) => x.cabina === String(dataAsignar.cabinaDropped),
  )

  if (indexCabina === -1) {
    pasajerosAsignados.push(newCabina)
    yield put(setPasajerosAsignados([...pasajerosAsignados]))
  } else {
    pasajerosAsignados[indexCabina].pasajeros.push(...dataAsignar.pasajerosDrop)
    yield put(setPasajerosAsignados([...pasajerosAsignados]))
  }

  const indexToDb = pasajerosAsignados.findIndex(
    (x) => x.cabina === String(dataAsignar.cabinaDropped),
  )

  try {
    const pasajerosModificados = structuredClone(
      pasajerosAsignados[indexToDb].pasajeros,
    )

    for (const newPasajero of pasajerosModificados) {
      if (newPasajero.asignacionPasajeroCabinaId === undefined) {
        // Los atributos de la asignación (acomodación, upgrade/downgrade, cabina de origen y
        // extensión) se toman de newCabina, o sea del drop actual: pasajerosAsignados agrupa por
        // número de cabina, así que la fila puede ser la del booking que ya estaba adentro y se
        // guardaba el upgrade y la acomodación del primer grupo.
        const objToDb = {
          PasajeroId: newPasajero.pasajeroId,
          EdadPasajero: newPasajero.edad,
          CabinaId: newCabina.cabinaId,
          NumeroTipoCabinaId: newCabina.numeroTipoCabinaId,
          NumeroCabina: newCabina.cabina,
          SalidaEmbarcacionId: newCabina.salidaEmbarcacionId,
          esUpgradeDowngrade: newCabina.isUpgrade,
          CabinaOrigenId: newCabina.cabinaOrigenId,
          ExtensionCrucero: newCabina.extensionCrucero,
          SalidaEmbarcacionExtensionId:
            newPasajero.salidaEmbarcacionPosteriorId,
          BookingCode: newPasajero.bookingCode,
          BookingDetailId: newPasajero.bookingDetailId,
        }
        const apiRes = yield call(post, 'AsignacionesPasajeroCabinas', objToDb)

        newPasajero.asignacionPasajeroCabinaId =
          apiRes.AsignacionPasajeroCabinaId
      }
    }

    // Se recorre solo el drop actual y no la fila agrupada: los pasajeros que ya estaban en la
    // cabina tienen su asignación de extensión creada desde antes y volver a postearla duplicaba
    // el registro en la salida siguiente.
    for (const i of dataAsignar.pasajerosDrop) {
      // La extension es de la CABINA, pero la salida siguiente es de cada PASAJERO. Con la guarda
      // mirando solo la extension, un pasajero sin salida posterior -su id viene en 0- generaba
      // igual un registro, y se posteaba con SalidaEmbarcacionId: 0: una asignacion que no
      // corresponde a ninguna salida real.
      if (newCabina.extensionCrucero === 'T' && i.salidaEmbarcacionPosteriorId) {
        // Si el pasajero YA tiene asignacion en la salida siguiente -por ejemplo porque se empezo
        // asignando por ella, que es un orden legitimo- volver a postear duplicaba el registro.
        // Ese duplicado despues no se ve en pantalla y solo aparece al desasignar, dejando una
        // asignacion huerfana en la otra salida (#41137).
        const yaAsignadoEnLaSiguiente = yield call(
          get,
          `AsignacionesPasajeroCabinas?$select=AsignacionPasajeroCabinaId&$filter=Eliminado eq false and PasajeroId eq ${i.pasajeroId} and SalidaEmbarcacionId eq ${i.salidaEmbarcacionPosteriorId}`,
        )

        if (yaAsignadoEnLaSiguiente?.value?.length > 0) {
          continue
        }

        const objToDb = {
          PasajeroId: i.pasajeroId,
          EdadPasajero: i.edad,
          CabinaId: newCabina.cabinaId,
          NumeroTipoCabinaId: newCabina.numeroTipoCabinaId,
          NumeroCabina: newCabina.cabina,
          SalidaEmbarcacionId: i.salidaEmbarcacionPosteriorId,
          esUpgradeDowngrade: newCabina.isUpgrade,
          CabinaOrigenId: newCabina.cabinaOrigenId,
          ExtensionCrucero: 'S',
          SalidaEmbarcacionExtensionId: null,
          BookingCode: i.bookingCode,
          BookingDetailId: i.bookingDetailPosteriorId,
        }

        yield call(post, 'AsignacionesPasajeroCabinas', objToDb)
      }
    }

    const pasajerosAsignadosModificados = pasajerosAsignados.map(
      (pasajeroAsignado, index) => {
        if (index === indexToDb) {
          return {
            ...pasajeroAsignado,
            pasajeros: pasajerosModificados,
          }
        }

        return pasajeroAsignado
      },
    )

    // update pasajeros asignados
    yield put(setPasajerosAsignados([...pasajerosAsignadosModificados]))

    notifications({
      title: `Éxito`,
      message: 'Se ingresó correctamente',
      toastType: 'success',
    })
  } catch (error) {
    notifications({ ex: error })

    // El rollback manual dejaba la pantalla mintiendo: splice(length, 1) no quita nada y devuelve
    // [], así que se despachaba setPasajerosAsignados([]) y TODAS las cabinas ocupadas pasaban a
    // verse vacías; changeClassCabin además ponía la cabina en cero pasajeros aunque el POST
    // hubiera guardado parte del drop. Se relee el estado real de la base, que cubre el guardado
    // parcial y los cambios que otro usuario hizo en paralelo.
    try {
      const { url, jsonData } = getDatosEmbarcacion(embarcacion)

      yield call(getPasajerosAsignados, salidaEmbarcacion)
      yield call(getCabinas, salidaEmbarcacion, embarcacion, url, jsonData)
    } catch (errorRecarga) {
      // Si la relectura tampoco responde, conservar el estado optimista es preferible a matar el
      // watcher del saga con una excepción sin atrapar (dejaría el deckplan sin responder).
      console.error('Deckplan: no se pudo recomponer el estado tras el error de asignación', errorRecarga)
    }
  } finally {
    yield call(getPasajerosEmbarcacion, salidaEmbarcacion)
    yield put(setLoading(false))
  }
}

function* getLoadData() {
  const { initialData }: StateDeckplan = yield select(Deckplan)
  const { salidaEmbarcacion, embarcacion } = initialData
  const { url, jsonData } = getDatosEmbarcacion(embarcacion)

  try {
    // all([call...]) corre en paralelo igual que los fork, pero permite apagar
    // cargandoInicial cuando TODO terminó (skeletons de header y lista)
    yield all([
      call(getPasajerosEmbarcacion, salidaEmbarcacion),
      call(getCabinas, salidaEmbarcacion, embarcacion, url, jsonData),
      call(getDataSalida, salidaEmbarcacion),
      call(getPasajerosAsignados, salidaEmbarcacion),
      call(getBloqueos, salidaEmbarcacion),
      call(getDisponibilidad, salidaEmbarcacion),
    ])
  } catch (error) {
    // Los fetchers individuales ya notifican su error al usuario; aquí solo
    // evitamos que un TypeError derivado dispare el toast genérico de 5xx
    console.error('Deckplan: error en carga inicial', error)
  } finally {
    yield put(setCargandoInicial(false))
  }
}

function* getPasajerosData() {
  const { initialData }: StateDeckplan = yield select(Deckplan)
  const { salidaEmbarcacion } = initialData

  yield fork(getPasajerosEmbarcacion, salidaEmbarcacion)
}

function* sendYield() {
  const { datosSalida, cabinas }: StateDeckplan = yield select(Deckplan)
  const { Nombre, FechaInicio, FechaFin } = datosSalida

  yield fork(
    generateYieldNotification,
    Nombre,
    FechaInicio.replace(/\//g, '-'),
    FechaFin.replace(/\//g, '-'),
    cabinas,
  )
}

function* desbloquearCabina(action: { type: string; payload: number }) {
  const { cabinas, bloqueos }: StateDeckplan = yield select(Deckplan)
  const indexCabins = cabinas.findIndex((x) => x.Numero === action.payload)

  yield fork(
    desbloquearCabinaByNumeroTipoCabina,
    cabinas[indexCabins].NumeroTipoCabinaId,
    indexCabins,
    cabinas,
    'cabsWhite',
    'cabsUp',
    bloqueos,
  )
}

function* abrirCabina(action: { type: string; payload: number }) {
  yield fork(abrirCabinaByNumero, action.payload)
}

function* asignarCabina() {
  const {
    dataAsignar,
    cabinas,
    initialData,
    dataAcomodaciones,
    pasajerosAsignados,
  }: StateDeckplan = yield select(Deckplan)

  yield fork(
    asignar,
    dataAsignar,
    cabinas,
    initialData,
    dataAcomodaciones,
    pasajerosAsignados,
  )
}

function* watchDeckplanLoadData() {
  yield takeEvery(DECKPLAN_LOAD_DATA, getLoadData)
}

function* watchDeckplanGetPasajeros() {
  yield takeEvery(DECKPLAN_GET_PASAJEROS_LISTA, getPasajerosData)
}

function* watchDeckplanSendYieldNotificaction() {
  yield takeEvery(DECKPLAN_SEND_YIELD_NOTIFICATION, sendYield)
}

function* watchDeckplanDesbloquearCabina() {
  yield takeEvery(DECKPLAN_DESBLOQUEAR_CABINA, desbloquearCabina)
}

function* watchDeckplanAbrirCabina() {
  yield takeEvery(DECKPLAN_ABRIR_CABINA, abrirCabina)
}

function* watchDeckplanAsignarCabina() {
  yield takeEvery(DECKPLAN_ASIGNAR_CABINA, asignarCabina)
}

function* deckplanSaga() {
  yield all([
    fork(watchDeckplanLoadData),
    fork(watchDeckplanGetPasajeros),
    fork(watchDeckplanSendYieldNotificaction),
    fork(watchDeckplanDesbloquearCabina),
    fork(watchDeckplanAbrirCabina),
    fork(watchDeckplanAsignarCabina),
  ])
}

export default deckplanSaga
